export default __webpack_public_path__ + "static/media/combine_step_2.24c2e247.gif";